import { applyTheme } from 'core/utils/theme';
import type { Theme } from 'core/interfaces/theme';

const STORAGE_KEY = 'voery-theme-mode';

/**
 * Тема воронки живёт в remote config (`theme: {"mode": "dark" | "light"}`) и
 * приезжает уже после первого рендера. Чтобы на тёмной теме экран не вспыхивал
 * белым до загрузки конфига, последний режим запоминаем локально и ставим
 * data-theme ещё до старта приложения.
 */
export const restoreThemeMode = () => {
  try {
    if (localStorage.getItem(STORAGE_KEY) === 'dark') {
      document.documentElement.setAttribute('data-theme', 'dark');
    }
  } catch (error) {
    // приватный режим/заблокированное хранилище — просто стартуем со светлой
  }
};

/** Ставит data-theme на :root по конфигу и запоминает режим для следующего старта. */
export const applyThemeMode = (theme?: Theme) => {
  const mode = theme?.mode === 'dark' ? 'dark' : 'light';

  applyTheme({ ...theme, mode });

  try {
    localStorage.setItem(STORAGE_KEY, mode);
  } catch (error) {
    // хранилище недоступно — тема всё равно применена к текущей сессии
  }
};
